import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';
import Image from '@nubank/nuds-web/components/Image/Image';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

function SectionMastercard({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Box
      tag="section"
      backgroundColor="white"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
    >
      <Grid
        paddingLeft={{ xs: '8x', md: '16x' }}
        paddingRight={{ xs: '8x', md: '16x' }}
        rowGap="12x"
        alignItems={{ lg: 'center' }}
      >
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '1 / span 5', lg: '8 / span 3' }}
        >
          <Typography
            variant="title"
            color="black"
            marginBottom="4x"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardTitle`}
          />
          {formatMessage({
            id: `cms.cardPage.cardCardsArea[${index}].cardSampleCardDescription`,
          }, {
            p: props => <Typography marginBottom="5x" variant="paragraph2" {...props} />,
            a: props => (
              <Link
                typographyProps={{
                  variant: 'paragraph2',
                }}
                {...props}
              />
            ),
          })}
        </Grid.Child>
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '3 / span 4', lg: '2 / span 5' }}
          gridRow={{ lg: '1' }}
        >
          <Image
            loading="lazy"
            srcSet={{
              xs: {
                '1x': 'roxinho-single/roxinho-single-xs@1x.jpg',
                '2x': 'roxinho-single/roxinho-single-xs@2x.jpg',
                '3x': 'roxinho-single/roxinho-single-xs@3x.jpg',
              },
              md: {
                '1x': 'roxinho-single/roxinho-single-md@1x.jpg',
                '2x': 'roxinho-single/roxinho-single-md@2x.jpg',
                '3x': 'roxinho-single/roxinho-single-md@3x.jpg',
              },
              lg: {
                '1x': 'roxinho-single/roxinho-single-lg@1x.jpg',
                '2x': 'roxinho-single/roxinho-single-lg@2x.jpg',
                '3x': 'roxinho-single/roxinho-single-lg@3x.jpg',
              },
            }}
            altIntlKey="CARD.MASTERCARD.IMAGE_CARD_ALT"
          />
        </Grid.Child>
      </Grid>
    </Box>
  );
}

SectionMastercard.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionMastercard);
